import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

/* CSS */
import '../../shared/components/form/inputDefault.css'
import '../stock/Stock.css'
import './StockGeneral.css'

/* form */
import Input from "../../shared/components/form/input"

/* Hooks */
import useMyPermission from '../../hooks/useMyPermission'

import ListStockItemRow from './ListRow/ListStockItemRow'
import Modal from '../../shared/modal/Modal'
import NewStockItem from './NewStockItem'
import Button from '../../shared/components/Button/Button'


function StockGeneral() {

    const [token] = useState(localStorage.getItem('token') || '')
    const [items, setItems] = useState([])
    const [modalNew, setModalNew] = useState(false)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionNew = checkPermission(myPermission, "stockGeneral_create")
    const myPermissionView = checkPermission(myPermission, "stockGeneral_view")
    const myPermissionEdit = checkPermission(myPermission, "stockGeneral_edit")
    const myPermissionDelete = checkPermission(myPermission, "stockGeneral_delete")

    const getAll = () => {
        api.get(`/stock/general/getall`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            if (response) {
                setItems(response.data.items)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return items.filter((item) => item.name.toLowerCase().includes(searchLowerCase))
    }, [items, search])

    const lowCount = useMemo(() => items.filter((i) => i.currentQuantity <= i.minQuantity).length, [items])

    function handleSearch(e) {
        setSearch(e.target.value)
    }

    if (!load) {
        return <div className="pg-loading">Carregando estoque geral...</div>
    }

    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Estoque Geral</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionNew && (
                                <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                            )}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por nome..."
                                    value={search}
                                    handleOnChange={handleSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'item' : 'itens'}
                                {lowCount > 0 && <span className="sg-low-count"> · {lowCount} abaixo do mínimo</span>}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListStockItemRow
                        dataArray={filter}
                        handleOnSuccess={getAll}
                        myPermissionEdit={myPermissionEdit}
                        myPermissionDelete={myPermissionDelete}
                        myPermissionView={myPermissionView}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum item encontrado</p>
                        <p className="pg-empty-subtitle">
                            {items.length === 0
                                ? 'Cadastre o primeiro item para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={80}
                content={
                    <NewStockItem btCancelAction={() => setModalNew(false)} handleOnSuccess={() => { setModalNew(false); getAll() }} />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar o estoque geral</p>
        </div>
    )
}

export default StockGeneral
